var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.445,
    height: 35.399,
    viewBox: "0 0 39.445 35.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_and_Black_arrow_free_icon_1",
    "data-name": "White and Black arrow free icon 1",
    transform: "translate(39.443 -10.443) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M45.8,38.776l-2.482-5.541-6.363-14.2-6.363-14.2L28.535.247c-.012-.028-.037-.04-.053-.063a.452.452,0,0,0-.06-.071.4.4,0,0,0-.136-.088.422.422,0,0,0-.055-.016.387.387,0,0,0-.176,0A.4.4,0,0,0,28,.024a.391.391,0,0,0-.137.088.43.43,0,0,0-.06.071c-.017.024-.041.035-.053.063L25.7,4.831l-6.363,14.2-6.363,14.2-2.483,5.541a.452.452,0,0,0,.55.634l5.359-2.22,11.747-4.865,11.747,4.865,5.359,2.22A.452.452,0,0,0,45.8,38.776ZM38.184,28.494l2.674,5.989L28.143,29.216V6.083l6.363,14.2Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.a0542e953dee2837c89f2986c250be45.svg";
export { ForwardRef as ReactComponent };